const COMPLETED_KEY = "meteotracker.tours.completed"
const WELCOME_KEY = "meteotracker.tours.welcomeSeen"

export function loadCompleted() {
  try {
    const parsed = JSON.parse(localStorage.getItem(COMPLETED_KEY) ?? "[]")
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export function saveCompleted(ids) {
  try {
    localStorage.setItem(COMPLETED_KEY, JSON.stringify(ids))
  } catch {
    // Private Mode / gesperrter Storage: Fortschritt gilt nur für die Sitzung
  }
}

export function loadWelcomeSeen() {
  try {
    return localStorage.getItem(WELCOME_KEY) === "1"
  } catch {
    return true
  }
}

export function saveWelcomeSeen() {
  try {
    localStorage.setItem(WELCOME_KEY, "1")
  } catch {
    // siehe saveCompleted
  }
}
